/**
 * The phase line's constants and its one formatter, separated from the component so that both
 * it and the action bar can import them without either file losing Fast Refresh.
 */

/**
 * Below this, the elapsed counter is noise — a turn that has been running four seconds is just
 * a turn. Past it, the player has started to wonder, and a number they can watch move is the
 * difference between "slow" and "broken".
 */
export const ELAPSED_VISIBLE_MS = 15_000;

/**
 * The action bar points its disabled controls at the phase line rather than restating it. The live turn
 * asks for "the phase label as the disabled reason", and one element carrying it is how that
 * is true without the same sentence appearing twice, six pixels apart.
 */
export const PHASE_LINE_ID = 'turn-phase';

/** `0:47`, `1:12`. Minutes only: no turn has ever taken an hour, and if one does, `73:20`. */
export function formatElapsed(ms: number): string {
  const total = Math.floor(ms / 1000);
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${String(minutes)}:${String(seconds).padStart(2, '0')}`;
}
